import { supabase } from './supabaseClient';

export const nzDateAfterDays = (days = 0, now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-NZ', { timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const get = (type: string) => Number(parts.find(part => part.type === type)?.value);
  const date = new Date(Date.UTC(get('year'), get('month') - 1, get('day') + days));
  return date.toISOString().slice(0, 10);
};
export const quoteValidUntil = (quote: any) => {
  const saved = quote?.quote_expiry_date ?? quote?.quoteExpiryDate;
  if (saved) return String(saved).slice(0, 10);
  const created = quote?.created_at ?? quote?.createdAt;
  if (!created || Number.isNaN(new Date(created).getTime())) return null;
  return nzDateAfterDays(14, new Date(created));
};
export const displayValidityDate = (date: string | null) => date
  ? new Date(`${date}T12:00:00`).toLocaleDateString('en-NZ') : 'TBD';
export const renewQuoteValidity = async (quoteId: string, validUntil: string) => {
  const { data, error } = await supabase.rpc('admin_renew_quote_validity', { p_quote_id: quoteId, p_valid_until: validUntil });
  if (error) throw error;
  return data as { quote_id: string; valid_until: string };
};
